module.exports = __webpack_public_path__ + "img/Sandrine-Azhar@3x.dd8f5eee.png";